import React from 'react';
import PropTypes from 'prop-types';
import ContentTeaser from '../Global/Teasers/ContentTeaser';
import NoResultsMessage from '../Global/Messages/NoResultsMessage';
import SectionHeading from '../Global/Typography/SectionHeading';

const TrainingGroundTeaserList = ({ title, subtitle, list, loading, userLocation, showThumbnails, viewMoreLink }) => {
  let trainingGroundTeaserList;
  if (list.length > 0) {
    trainingGroundTeaserList = (
      <div>
        <ul className="list-row row">
          {list.map((listItem) => {
            const { id, slug, plaintext_summary, author_full_name, type, tcm_age_range, usa_age_range, thumbnail_image_url, stream_image_url, is_new } = listItem;
            return (
              <li key={id} className="training-ground-teaser-list__list-item col-xs-6 col-xl-3 d-flex">
                <ContentTeaser
                  href={slug}
                  title={listItem.title}
                  summary={plaintext_summary}
                  authorName={author_full_name}
                  type={type}
                  tcmAgeRange={tcm_age_range}
                  usaAgeRange={usa_age_range}
                  userLocation={userLocation}
                  heroImage={thumbnail_image_url}
                  streamImage={stream_image_url.M}
                  isNew={is_new}
                  showImage={showThumbnails}
                  hasVideo={showThumbnails}
                />
              </li>
            );
          })}
        </ul>

        {viewMoreLink &&
          <div className="hidden-md-up m-t-5">
            <a href={viewMoreLink} className="btn btn--tertiary p-a-3 text-center border-radius-l d-block">View all</a>
          </div>
        }
      </div>
    );
  } else {
    trainingGroundTeaserList = (
      <NoResultsMessage
        title="No content available"
        loading={loading}
        border
      />
    );
  }

  return (
    <div className="training-ground-teaser-list">
      <SectionHeading title={title} subtitle={subtitle} viewMoreLink={viewMoreLink} />
      {trainingGroundTeaserList}
    </div>
  );
};

TrainingGroundTeaserList.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  list: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  userLocation: PropTypes.string,
  showThumbnails: PropTypes.bool,
  viewMoreLink: PropTypes.string,
};

export default TrainingGroundTeaserList;



// WEBPACK FOOTER //
// ./library/app/components/TrainingGround/TrainingGroundTeaserList.js